module.exports = __webpack_public_path__ + "static/media/Home Page Sero.4852429c.png";